(function () {
  var root = document.querySelector('[data-shop-filters]');
  var shopRoot = document.querySelector('[data-shop-root]');
  if (!root || !shopRoot) return;

  var searchInput = root.querySelector('[data-shop-search]');
  var sortSelect = root.querySelector('[data-gallery-sort]');
  var clearBtn = root.querySelector('[data-shop-clear]');
  var countEl = root.querySelector('[data-gallery-count]');
  var grid = document.querySelector('[data-gallery-grid]');
  var pagerHost = shopRoot.querySelector('[data-shop-pager-host]');

  var config = window.GravityShop || {};
  var collectionHandle =
    config.collectionHandle ||
    shopRoot.dataset.collection ||
    document.documentElement.dataset.catalogCollection || 'all-in-stock';
  var perPage = parseInt(config.perPage || shopRoot.dataset.perPage || '24', 10);
  var totalCount = parseInt(
    config.totalCount || shopRoot.dataset.totalCount || '0',
    10
  );

  var CACHE_VERSION = 5;
  var cacheKey =
    'gravity-shop-catalog-v' +
    CACHE_VERSION +
    ':' +
    collectionHandle +
    ':' +
    totalCount;

  var SIZE_DIMS = {
    XS: '1.2 × 2.4m',
    Standard: '1.6 × 2.7m',
    Mid: '1.9 × 2.7m',
    Large: '2.1 × 2.7m',
    'Large+': '2.7 × 3m',
    XL: '2.7 × 4m',
    XXL: '2.7 × 5m',
    XXXL: '2.7 × 6m',
  };

  var catalog = [];
  var fullCatalog = null;
  var fullCatalogLoading = false;
  var fullCatalogError = null;
  var ssrIntact = true;
  var renderEpoch = 0;
  var searchTimer = null;

  var state = {
    q: '',
    size: 'all',
    color: 'all',
    tex: 'all',
    sort: 'manual',
    page: 1,
  };

  function formatMoney(dollars) {
    return new Intl.NumberFormat('en-EU', { style: 'currency', currency: 'EUR' }).format(
      parseFloat(dollars) || 0
    );
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function needsFullCatalog() {
    return (
      state.size !== 'all' ||
      state.color !== 'all' ||
      state.tex !== 'all' ||
      !!state.q ||
      state.sort !== 'manual'
    );
  }

  function colorMatchesFilter(productColor) {
    var opts = window.GRAVITY_FILTER_OPTIONS;
    if (opts && opts.colorMatchesFilter) {
      return opts.colorMatchesFilter(productColor, state.color);
    }
    if (state.color === 'all') return true;
    return productColor === state.color;
  }

  function productMatches(p) {
    if (state.size !== 'all' && p.size !== state.size) return false;
    if (!colorMatchesFilter(p.color)) return false;
    if (state.tex !== 'all' && p.tex !== state.tex) return false;
    if (state.q) {
      var hay = [p.code, p.title, p.color, p.tex, p.size, p.displayName]
        .join(' ')
        .toLowerCase();
      if (hay.indexOf(state.q.toLowerCase()) === -1) return false;
    }
    return true;
  }

  function cardElMatches(card) {
    if (state.size !== 'all' && card.getAttribute('data-size') !== state.size) return false;
    if (!colorMatchesFilter(card.getAttribute('data-color'))) return false;
    if (state.tex !== 'all' && card.getAttribute('data-tex') !== state.tex) return false;
    if (state.q) {
      var hay = [
        card.getAttribute('data-code'),
        card.getAttribute('data-title'),
        card.getAttribute('data-color'),
        card.getAttribute('data-tex'),
        card.getAttribute('data-size'),
      ]
        .join(' ')
        .toLowerCase();
      if (hay.indexOf(state.q.toLowerCase()) === -1) return false;
    }
    return true;
  }

  function isRawProductAvailable(product) {
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return true;
    }
    return false;
  }

  function filterAvailableRaw(products) {
    return products.filter(isRawProductAvailable);
  }

  function filterAvailableNormalized(products) {
    return products.filter(function (p) {
      return p.available !== false;
    });
  }

  function getInStockTotalCount() {
    return fullCatalog ? fullCatalog.length : totalCount;
  }

  function refreshInStockTotalCount() {
    if (!fullCatalog) return;
    totalCount = fullCatalog.length;
    if (config) config.totalCount = totalCount;
  }

  function onFullCatalogReady() {
    refreshInStockTotalCount();
    if (!needsFullCatalog()) {
      if (
        state.page === 1 &&
        ssrIntact &&
        grid &&
        grid.querySelector('[data-product-card]')
      ) {
        renderBrowseMode();
        if (window.GravityCart && window.GravityCart.syncShopCards) {
          window.GravityCart.syncShopCards();
        }
        return;
      }
      applyStateAndRender();
    }
  }

  function getOption(product, name) {
    var options = product.options || [];
    for (var i = 0; i < options.length; i++) {
      if (options[i].name === name && options[i].values && options[i].values[0]) {
        return options[i].values[0];
      }
    }
    return '';
  }

  function firstAvailableVariant(product) {
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return variants[0] || {};
  }

  function normalizeProduct(product) {
    var variant = firstAvailableVariant(product);
    var titleParts = (product.title || '').split(' ');
    var code = titleParts[0] || '';
    var size = product.product_type || getOption(product, 'Size') || '';
    var colorRaw = getOption(product, 'Color') || '';
    var color = colorRaw.toLowerCase();
    var texRaw = getOption(product, 'Texture') || '';
    var tex = texRaw.replace(/ texture$/i, '').trim();
    var displayName = colorRaw || product.title.replace(/^\S+\s*/, '').slice(0, 40);
    var price = parseFloat(variant.price || '0');

    return {
      id: product.id,
      variantId: variant.id || '',
      handle: product.handle,
      url: '/products/' + product.handle,
      title: product.title,
      code: code,
      size: size,
      color: color,
      tex: tex,
      displayName: displayName,
      price: price,
      createdAt: product.created_at || '',
      image: product.images && product.images[0] ? product.images[0].src : '',
      dims: SIZE_DIMS[size] || '',
      available: isRawProductAvailable(product),
    };
  }

  function parseDomCatalog() {
    if (!grid) return [];
    return Array.prototype.slice
      .call(grid.querySelectorAll('[data-product-card]'))
      .map(function (card) {
        var priceEl = card.querySelector('.gravity-shop__card-price');
        var priceText = priceEl ? priceEl.textContent : '0';
        var price = parseFloat(priceText.replace(/[^\d.,]/g, '').replace(',', '.')) || 0;

        return {
          id: card.getAttribute('href'),
          variantId: card.getAttribute('data-variant-id') || '',
          handle: (card.getAttribute('href') || '').split('/').pop(),
          url: card.getAttribute('href'),
          title: card.getAttribute('data-title') || '',
          code: card.getAttribute('data-code') || '',
          size: card.getAttribute('data-size') || '',
          color: card.getAttribute('data-color') || '',
          tex: card.getAttribute('data-tex') || '',
          displayName: '',
          price: price,
          createdAt: '',
          image: card.querySelector('img') ? card.querySelector('img').src : '',
          dims: SIZE_DIMS[card.getAttribute('data-size')] || '',
        };
      });
  }

  function readUrlState() {
    var params = new URLSearchParams(window.location.search);

    state.size = params.get('size') || params.get('filter.p.product_type') || 'all';
    var colorParam = params.get('color') || params.get('filter.v.option.color');
    if (colorParam) {
      var opts = window.GRAVITY_FILTER_OPTIONS;
      var rawColor = colorParam.toLowerCase();
      state.color = opts && opts.parentColor ? opts.parentColor(rawColor) : rawColor;
    } else {
      state.color = 'all';
    }
    var texParam = params.get('tex') || params.get('filter.v.option.texture');
    state.tex = texParam ? texParam.replace(/ texture$/i, '') : 'all';
    state.q = params.get('q') || '';
    state.sort = params.get('sort_by') || params.get('sort') || 'manual';
    state.page = Math.max(1, parseInt(params.get('page') || '1', 10));

    if (searchInput) searchInput.value = state.q;
    if (sortSelect) sortSelect.value = state.sort;
  }

  function syncUrl() {
    var url = new URL(window.location.href);
    url.searchParams.delete('filter.p.product_type');
    url.searchParams.delete('filter.v.option.color');
    url.searchParams.delete('filter.v.option.texture');
    url.searchParams.delete('filter.v.option.size');

    if (state.size !== 'all') url.searchParams.set('size', state.size);
    else url.searchParams.delete('size');

    if (state.color !== 'all') url.searchParams.set('color', state.color);
    else url.searchParams.delete('color');

    if (state.tex !== 'all') url.searchParams.set('tex', state.tex);
    else url.searchParams.delete('tex');

    if (state.q) url.searchParams.set('q', state.q);
    else url.searchParams.delete('q');

    if (state.sort && state.sort !== 'manual') url.searchParams.set('sort_by', state.sort);
    else url.searchParams.delete('sort_by');

    if (state.page > 1) url.searchParams.set('page', String(state.page));
    else url.searchParams.delete('page');

    window.history.replaceState({}, '', url.toString());
  }

  function initFilterChips() {
    var opts = window.GRAVITY_FILTER_OPTIONS;
    if (!opts || !opts.renderChipRow) return;
    opts.renderChipRow(root.querySelector('[data-chip-row="color"]'), 'color', opts.colors, state.color);
    opts.renderChipRow(root.querySelector('[data-chip-row="tex"]'), 'tex', opts.textures, state.tex);
  }

  function syncChips() {
    root.querySelectorAll('.gravity-shop__chip').forEach(function (chip) {
      var key = chip.getAttribute('data-filter-key');
      var val = chip.getAttribute('data-filter-val');
      chip.setAttribute('aria-pressed', state[key] === val ? 'true' : 'false');
    });
  }

  function setCountLoading(loading, previewVisible) {
    if (!countEl) return;
    countEl.classList.toggle('is-loading', loading);
    if (loading && needsFullCatalog()) {
      if (typeof previewVisible === 'number') {
        countEl.textContent =
          previewVisible +
          ' on this page · loading full catalogue…';
      } else {
        countEl.textContent = 'Searching the full catalogue…';
      }
    }
  }

  function setGridLoading(loading) {
    if (grid) grid.classList.toggle('is-loading', loading);
  }

  function applyDomPreview() {
    if (!grid || !ssrIntact) return 0;
    var cards = grid.querySelectorAll('[data-product-card]');
    var visible = 0;
    cards.forEach(function (card) {
      var show = cardElMatches(card);
      card.hidden = !show;
      if (show) visible += 1;
    });
    return visible;
  }

  function clearDomPreview() {
    if (!grid) return;
    grid.querySelectorAll('[data-product-card][hidden]').forEach(function (card) {
      card.hidden = false;
    });
  }

  function sortProducts(list) {
    if (state.sort === 'price-ascending') {
      list.sort(function (a, b) {
        return a.price - b.price;
      });
    } else if (state.sort === 'price-descending') {
      list.sort(function (a, b) {
        return b.price - a.price;
      });
    } else if (state.sort === 'title-ascending') {
      list.sort(function (a, b) {
        return a.title.localeCompare(b.title);
      });
    } else if (state.sort === 'title-descending') {
      list.sort(function (a, b) {
        return b.title.localeCompare(a.title);
      });
    } else if (state.sort === 'created-descending') {
      list.sort(function (a, b) {
        return (b.createdAt || '').localeCompare(a.createdAt || '');
      });
    }
    return list;
  }

  function filteredProducts(source) {
    var list = filterAvailableNormalized(source).filter(productMatches);
    return sortProducts(list);
  }

  function loadCatalogCache() {
    try {
      var raw = sessionStorage.getItem(cacheKey);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !Array.isArray(parsed.products)) return null;
      if (parsed.complete === false) return null;
      if (
        totalCount &&
        parsed.sourceCount &&
        parsed.sourceCount < totalCount * 0.95
      ) {
        return null;
      }
      return filterAvailableNormalized(parsed.products);
    } catch (e) {
      return null;
    }
  }

  function saveCatalogCache(products, sourceCount) {
    try {
      sessionStorage.setItem(
        cacheKey,
        JSON.stringify({
          savedAt: Date.now(),
          products: products,
          sourceCount: sourceCount || products.length,
          complete: !totalCount || !sourceCount || sourceCount >= totalCount * 0.95,
        })
      );
    } catch (e) {
      /* quota or private mode */
    }
  }

  function cardHtml(product, index) {
    var sub =
      (product.tex ? product.tex + ' texture' : '') +
      (product.dims ? ' · ' + product.dims : '');
    var delay = (index % perPage) * 30;
    var displayName = product.displayName || product.color || product.title;

    return (
      '<a class="gravity-shop__card" href="' +
      esc(product.url) +
      '" data-product-card data-size="' +
      esc(product.size) +
      '" data-color="' +
      esc(product.color) +
      '" data-tex="' +
      esc(product.tex) +
      '" data-title="' +
      esc(product.title) +
      '" data-code="' +
      esc(product.code) +
      '" data-variant-id="' +
      esc(product.variantId) +
      '" style="--card-delay:' +
      delay +
      'ms">' +
      '<div class="gravity-shop__card-media">' +
      (product.size
        ? '<span class="gravity-shop__card-tag">' + esc(product.size) + '</span>'
        : '') +
      (product.image
        ? '<img src="' +
          esc(product.image) +
          '" alt="' +
          esc(product.title) +
          '" loading="lazy" class="gravity-shop__card-img" width="600" height="800">'
        : '') +
      '<div class="gravity-shop__card-quick"><span class="gravity-shop__card-quick-label">Quick view</span></div>' +
      '</div>' +
      '<div class="gravity-shop__card-body">' +
      '<div class="gravity-shop__card-name">' +
      esc(product.code) +
      ' · ' +
      esc(displayName) +
      '</div>' +
      '<div class="gravity-shop__card-meta">' +
      '<span class="gravity-shop__card-sub">' +
      esc(sub) +
      '</span>' +
      '<span class="gravity-shop__card-price">' +
      formatMoney(product.price) +
      '</span>' +
      '</div></div></a>'
    );
  }

  function renderPager(pages) {
    if (!pagerHost) return;
    pagerHost.innerHTML = '';
    if (pages <= 1) return;

    var nav = document.createElement('nav');
    nav.className = 'gravity-shop__pager';
    nav.setAttribute('aria-label', 'Product pagination');

    var html = '';
    if (state.page > 1) {
      html +=
        '<button type="button" class="gravity-shop__pager-nav" data-page="' +
        (state.page - 1) +
        '">← Prev</button>';
    } else {
      html +=
        '<button type="button" class="gravity-shop__pager-nav" disabled style="opacity:.35">← Prev</button>';
    }

    for (var i = 1; i <= pages; i++) {
      if (pages > 7 && i > 3 && i < pages - 1 && Math.abs(i - state.page) > 1) {
        if (i === 4) html += '<span aria-hidden="true">…</span>';
        continue;
      }
      if (i === state.page) {
        html += '<span aria-current="page">' + i + '</span>';
      } else {
        html += '<button type="button" data-page="' + i + '">' + i + '</button>';
      }
    }

    if (state.page < pages) {
      html +=
        '<button type="button" class="gravity-shop__pager-nav" data-page="' +
        (state.page + 1) +
        '">Next →</button>';
    } else {
      html +=
        '<button type="button" class="gravity-shop__pager-nav" disabled style="opacity:.35">Next →</button>';
    }

    nav.innerHTML = html;
    pagerHost.appendChild(nav);

    nav.querySelectorAll('[data-page]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.page = parseInt(btn.getAttribute('data-page'), 10);
        applyStateAndRender();
        var top = root.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  function renderGrid(products) {
    if (!grid) return;
    ssrIntact = false;
    clearDomPreview();

    if (!products.length) {
      grid.innerHTML =
        '<div class="gravity-shop__empty"><h3>No canvases match.</h3><p>Try clearing a filter or search term.</p></div>';
      return;
    }

    grid.innerHTML = products.map(cardHtml).join('');
    if (window.GravityCart && window.GravityCart.syncShopCardsFromCache) {
      window.GravityCart.syncShopCardsFromCache();
    }
    if (window.GravityCart && window.GravityCart.syncShopCards) {
      window.GravityCart.syncShopCards();
    }
  }

  function updateCount(shown, total) {
    if (!countEl) return;
    countEl.classList.remove('is-loading');
    var n = typeof total === 'number' ? total : shown;
    countEl.textContent =
      n + ' hand-painted ' + (n === 1 ? 'backdrop' : 'backdrops');
  }

  function renderBrowseMode() {
    var inStockTotal = getInStockTotalCount();
    var pages = Math.max(1, Math.ceil(inStockTotal / perPage));
    if (state.page > pages) state.page = pages;

    updateCount(inStockTotal);
    renderPager(pages);
    syncUrl();
    syncChips();
  }

  function renderFilteredMode(list, epoch) {
    if (epoch !== renderEpoch) return;

    var pages = Math.max(1, Math.ceil(list.length / perPage));
    if (state.page > pages) state.page = 1;

    var slice = list.slice((state.page - 1) * perPage, state.page * perPage);
    updateCount(list.length);
    renderGrid(slice);
    renderPager(pages);
    syncUrl();
    syncChips();
    setGridLoading(false);
    setCountLoading(false);
  }

  function fetchBrowsePage(page) {
    return fetch(
      '/collections/' +
        encodeURIComponent(collectionHandle) +
        '/products.json?limit=' +
        perPage +
        '&page=' +
        page
    ).then(function (res) {
      if (!res.ok) throw new Error('Failed to load products');
      return res.json();
    });
  }

  function fetchProductsPage(page) {
    return fetch(
      '/collections/' +
        encodeURIComponent(collectionHandle) +
        '/products.json?limit=250&page=' +
        page
    ).then(function (res) {
      if (!res.ok) throw new Error('Failed to load products (page ' + page + ')');
      return res.json();
    });
  }

  function waitForCatalogLoad() {
    return new Promise(function (resolve, reject) {
      var tick = function () {
        if (fullCatalog) {
          resolve(fullCatalog);
          return;
        }
        if (!fullCatalogLoading) {
          if (fullCatalogError) reject(fullCatalogError);
          else resolve(fullCatalog);
          return;
        }
        setTimeout(tick, 40);
      };
      tick();
    });
  }

  async function fetchAllCatalogPages() {
    var pageSize = 250;
    var maxPages = totalCount
      ? Math.ceil(totalCount / pageSize)
      : 40;
    var concurrency = 5;
    var products = [];

    for (var start = 1; start <= maxPages; start += concurrency) {
      var pageNums = [];
      for (var p = start; p < start + concurrency && p <= maxPages; p++) {
        pageNums.push(p);
      }

      var chunk = await Promise.all(pageNums.map(fetchProductsPage));
      var added = 0;

      chunk.forEach(function (data) {
        var list = data.products || [];
        added += list.length;
        products = products.concat(list);
      });

      if (added === 0) break;
      if (totalCount && products.length >= totalCount) break;

      var tail = chunk[chunk.length - 1];
      if (!tail || !tail.products || tail.products.length < pageSize) break;
    }

    return products;
  }

  async function ensureFullCatalog() {
    if (fullCatalog) return fullCatalog;

    var cached = loadCatalogCache();
    if (cached) {
      fullCatalog = cached;
      refreshInStockTotalCount();
      return fullCatalog;
    }

    if (fullCatalogLoading) {
      await waitForCatalogLoad();
      if (fullCatalog) return fullCatalog;
      if (fullCatalogError) throw fullCatalogError;
      return ensureFullCatalog();
    }

    fullCatalogLoading = true;
    fullCatalogError = null;

    try {
      var rawProducts = await fetchAllCatalogPages();
      fullCatalog = filterAvailableRaw(rawProducts).map(normalizeProduct);
      saveCatalogCache(fullCatalog, rawProducts.length);
      refreshInStockTotalCount();
      return fullCatalog;
    } catch (err) {
      fullCatalogError = err;
      throw err;
    } finally {
      fullCatalogLoading = false;
    }
  }

  async function applyStateAndRender() {
    var epoch = ++renderEpoch;
    syncChips();
    syncUrl();

    if (needsFullCatalog()) {
      var previewVisible = applyDomPreview();
      setCountLoading(true, previewVisible);
      if (!fullCatalog) {
        setGridLoading(previewVisible === 0);
        if (pagerHost) pagerHost.innerHTML = '';
      }

      if (fullCatalog) {
        renderFilteredMode(filteredProducts(fullCatalog), epoch);
        return;
      }

      try {
        var source = await ensureFullCatalog();
        if (epoch !== renderEpoch) return;
        renderFilteredMode(filteredProducts(source), epoch);
      } catch (err) {
        if (epoch !== renderEpoch) return;
        console.error('Gravity shop filter load failed', err);
        if (countEl) {
          countEl.textContent = 'Could not load catalogue — try again';
          countEl.classList.remove('is-loading');
        }
        setGridLoading(false);
      }
      return;
    }

    clearDomPreview();

    if (fullCatalog) {
      if (
        state.page === 1 &&
        ssrIntact &&
        !needsFullCatalog() &&
        grid &&
        grid.querySelector('[data-product-card]')
      ) {
        catalog = parseDomCatalog();
        renderBrowseMode();
        setGridLoading(false);
        setCountLoading(false);
        if (window.GravityCart && window.GravityCart.syncShopCards) {
          window.GravityCart.syncShopCards();
        }
        return;
      }
      renderFilteredMode(filteredProducts(fullCatalog), epoch);
      setGridLoading(false);
      setCountLoading(false);
      return;
    }

    if (state.page === 1) {
      if (ssrIntact && grid && grid.querySelector('[data-product-card]')) {
        catalog = parseDomCatalog();
        renderBrowseMode();
        setGridLoading(false);
        setCountLoading(false);
        return;
      }

      setGridLoading(true);
      try {
        var firstPage = await fetchBrowsePage(1);
        if (epoch !== renderEpoch) return;
        catalog = filterAvailableRaw(firstPage.products || []).map(normalizeProduct);
        renderGrid(catalog);
        renderBrowseMode();
      } catch (err) {
        console.error('Gravity shop page 1 load failed', err);
      } finally {
        setGridLoading(false);
        setCountLoading(false);
      }
      return;
    }

    setGridLoading(true);
    try {
      var pageData = await fetchBrowsePage(state.page);
      if (epoch !== renderEpoch) return;
      catalog = filterAvailableRaw(pageData.products || []).map(normalizeProduct);
      renderGrid(catalog);
      renderBrowseMode();
    } catch (err) {
      console.error('Gravity shop page load failed', err);
    } finally {
      setGridLoading(false);
      setCountLoading(false);
    }
  }

  readUrlState();
  initFilterChips();

  var cachedAtStart = loadCatalogCache();
  if (cachedAtStart) {
    fullCatalog = cachedAtStart;
    refreshInStockTotalCount();
  }

  catalog = parseDomCatalog();
  renderBrowseMode();
  if (window.GravityCart && window.GravityCart.syncShopCards) {
    window.GravityCart.syncShopCards();
  }

  function prefetchCatalog() {
    ensureFullCatalog()
      .then(onFullCatalogReady)
      .catch(function () {
        /* background warm-up only */
      });
  }

  if (!fullCatalog) {
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(prefetchCatalog, { timeout: 1500 });
    } else {
      setTimeout(prefetchCatalog, 50);
    }
  }

  if (needsFullCatalog()) {
    applyStateAndRender();
  } else if (state.page > 1) {
    applyStateAndRender();
  }

  root.querySelectorAll('.gravity-shop__chip').forEach(function (chip) {
    chip.addEventListener('click', function () {
      var key = chip.getAttribute('data-filter-key');
      var val = chip.getAttribute('data-filter-val');
      state[key] = val;
      state.page = 1;
      applyStateAndRender();
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      state.q = searchInput.value.trim();
      state.page = 1;
      clearTimeout(searchTimer);
      searchTimer = setTimeout(applyStateAndRender, 280);
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      try {
        sessionStorage.removeItem(cacheKey);
      } catch (e) {
        /* ignore */
      }
      window.location.href = window.location.pathname;
    });
  }

  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      state.sort = sortSelect.value;
      state.page = 1;
      applyStateAndRender();
    });
  }
})();
